'use client';

import type { ReactNode } from 'react';
import type { NodeProps } from '../types';

export type AnchorLinkProps = NodeProps<{
  children: ReactNode;
  target: string;
}> & { nested?: boolean };

export function AnchorLink({ props }: AnchorLinkProps) {
  const handleClick = () => {
    if (!props.target) return;

    const target = document.getElementById(props.target);
    if (!target) return;

    target.style.scrollMarginTop = '100px';
    target.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' });
  };

  return (
    <a
      className="text-secondary-foreground no-underline hover:underline"
      href={`#${props.target}`}
      rel="nofollow noopener noreferrer"
      target="_self"
      onClick={handleClick}
    >
      {props.children}
    </a>
  );
}
